import axios from "axios";

const domain = process.env.VUE_APP_API_URL_IZBL;
const baseUrl = `${domain}/viewer`;

export default axios.create({
    baseURL : baseUrl,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
      }
});